module.exports = __webpack_public_path__ + "static/media/blackFriday_sm.f6170a8e.png";